import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import * as actions from '../../actions/layout';
import { closeAuthError } from '../../actions/auth';

const mapStateToProps = ({ auth, layout }) => ({
  token: auth.token,
  error: auth.error,
  data: layout.data,
  links: layout.links,
  ssoAuth: auth.ssoAuth
});

const mapDispatchToProps = dispatch => ({
  didMount: () => dispatch(actions.layout()),
  closeModal: () => dispatch(closeAuthError()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
